import React from 'react';
import { KeenIcon } from '@/components';
import { Header, Toolbar, Table } from './popup';

const ManageModal = ({
  type = 'reference-data',
  open,
  onClose,
  tableProps = {}
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-lg shadow-lg w-[90vw] max-w-5xl min-h-[80%] relative p-0">
        <Header type={type} onClose={onClose} />
        <div className="px-6 pt-2 pb-4">
          <Toolbar type={type} />
          <Table {...tableProps} />
        </div>
      </div>
    </div>
  );
};

export { ManageModal }; 